import PageContextWrapper from "@components/Components/Reusables/PageContextWrapper";
import StaticPage from "Features/ECOMM/StaticPages/components/StaticPage";
import dynamic from "next/dynamic";
const AboutUsSchema = dynamic(() => import("../js/Components/Schemas/AboutUsSchema"));
// const AboutUs = dynamic(() => import("../js/Components/AboutUs/AboutUs"));

//Dynamically load the home component and return it
const aboutus = ({ data }) => {

    return (
        <PageContextWrapper
            page='aboutus'
            page_content={data.template_page_content}
        >
            <AboutUsSchema />
            <StaticPage
                {...data}
                mobileClasses="p-2"
            />
        </PageContextWrapper>
    );
};

export async function getServerSideProps({ query, res }) {
    try {
        const req = await fetch(`${process.env.NEXT_PUBLIC_BASE_API_URL}aboutus`);
        const data = await req.json()

        if (data.exception) {
            return { notFound: true }
        }

        return {
            props: {
                data
            },
        };

    } catch (error) {
        return { notFound: true } //404
    }
}

// export async function getStaticProps({ query, res }) {
//     try {
//         const req = await fetch(`${process.env.NEXT_PUBLIC_BASE_API_URL}aboutus`);
//         const data = await req.json()

//         if(data.exception) {
//             return {notFound: true}
//         }

//         return {
//             props: {
//                 data
//              },
//         };

//     } catch (error) {
//         return {notFound: true} //404
//     }
// }

export default aboutus;
